import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';

import MenuButton from 'client/components/suc/Navbar/MenuButton/MenuButton';
import { useLocation } from 'react-router';

const Links = ({ children, ...props }) => {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const deviceType = useDeviceType();
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <div className="govuk-header__content js-enabled" data-testid="navbar.links">
            <nav
                id="navigation"
                data-testid="navbar.links.nav"
                className="govuk-header__navigation govuk-header__navigation--end"
                aria-label={intl.formatMessage({ id: 'navbar.links.ariaLabel' })}
                role="navigation"
            >
                { deviceType !== DESKTOP
                    ? <MenuButton open={open} onPress={() => setOpen((!open))}/>
                    : null
                }

                { open || deviceType === DESKTOP
                    ? <ul
                        data-testid="navbar.links.menu"
                        className="govuk-header__navigation-list"
                        role="menubar"
                    >
                        {children}
                    </ul>
                    : null
                }
            </nav>
        </div>
    );
};

Links.propTypes = {
    children: PropTypes.any
};

export default Links;
